import * as React from "react"
import { Container, Box, Text, Section, Flex, Heading, Subhead, Card, Space, FlexList } from "../../ui"
import { StaticImage } from "gatsby-plugin-image"
import { AiFillCheckCircle, AiFillStar } from "react-icons/ai";
import { bizzlab, lightcolor_5, bold, lightcolor_6, college_card, spancolor_5, spancolor, marginTop, text_justify } from "../../ui.css";
export default function Business_laboratory(props) {
    return (
        <Section style={{ color: "#081F32" }}>


            <Container width="narrow2">
                <Section>
                    <Flex gap={4} variant="responsive" className={bizzlab}>
                        <Box>
                            <Subhead>
                                Business Laboratory in Your College
                            </Subhead>
                            <Text className={`${lightcolor_5} ${bold}`}>
                                Establish a business lab in Commerce Colleges
                            </Text>
                        </Box>
                    </Flex>
                </Section>
                <Container >
                    <Flex gap={4} variant="responsive">
                        <Box>
                            <Subhead> <span style={{ color: "#4367EC" }}> Business</span> Laboratory</Subhead>
                            <Text  className={`${lightcolor_6} ${text_justify}`}>It is a virtual platform designed for Commerce students in a college, that offers working environment in online mode. It has integrated 20 top skills that are required in Accounts and Finance filed, that are very much essential to work in the industry. Using these virtual platform, student  can experiment their subject knowledge in the practical scenario. 	This platform gives an opportunity to work  in a virtual  company where lakhs of transaction of Industry  are available.	</Text>

                            <FlexList>
                                <li> <Text><AiFillCheckCircle className={spancolor} /> <br/>&nbsp;</Text></li>
                                <li> <Text>It addresses the University mandate that every college must have a business lab.</Text></li>
                            </FlexList>

                            <FlexList>
                                <li>
                                    <Text> <AiFillCheckCircle className={spancolor} /></Text></li>
                                <li>  <Text> Commerce graduation can be offered with Industry work	experience..</Text></li>
                            </FlexList>


                        </Box>
                        <Box>
                            <Flex gap={4} variant="responsive">
                                <Box className={marginTop}>
                                    <Card style={{ margin: "0 50px 15px 50px" }} className={college_card}>
                                        <StaticImage src='../../../images/college_images/verified_cv_certificate.png' alt="verified_cv_certificate" width={30} />
                                        <Text className={lightcolor_6}>It helps in offering Skill Development score</Text>
                                    </Card>
                                    <Card style={{ margin: "0 50px 10px 50px" }} className={college_card}>
                                        <StaticImage src='../../../images/college_images/star.png' alt="verified_cv_certificate" width={30} />
                                        <Text className={lightcolor_6}>It helps in getting NAAC Accreditation	</Text>
                                    </Card>
                                </Box>
                                <Box>
                                    <Card style={{ margin: "0 50px 10px 50px" }} className={college_card}>
                                        <StaticImage src='../../../images/college_images/naac.png' alt="verified_cv_certificate" width={40} />
                                        <Text className={lightcolor_6}>It helps in creating a good brand image for the College</Text>
                                    </Card>
                                    <Card style={{ margin: "0 50px 10px 50px" }} className={college_card}>
                                        <StaticImage src='../../../images/college_images/graph.png' alt="verified_cv_certificate" width={30} />
                                        <Text className={lightcolor_6}>Increase the number of college admissions</Text>
                                    </Card>
                                </Box>
                            </Flex>
                        </Box>
                    </Flex>
                </Container>
            </Container>
        </Section>
    )
}
